import { render, staticRenderFns } from "./SumupEdit.vue?vue&type=template&id=38d806e4&"
import script from "./SumupEdit.vue?vue&type=script&lang=ts&"
export * from "./SumupEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports